import { Section } from '@/src/containers/Landings/Section';
import styles from './BrandedContent.module.scss';
import Video from './Video';
import { Typography } from '@/src/shared/components/Typography';
import { CtaButton } from '../CtaButton';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

export const BrandedContent = () => {
  const isMobile = useIsMobile();

  return (
    <Section className={styles.container}>
      <div className={styles.videoWrapper}>
        <Video />
      </div>
      <div className={styles.content}>
        <Typography
          variant="heading"
          size={isMobile ? 'h5' : 'h4'}
          tag={isMobile ? 'h5' : 'h4'}
        >
          Branded Content,
          <br />
          Posted for You
        </Typography>
        <Typography variant="text" size="xl" fontWeight="regular">
          Branded videos and slideshows featuring your voice and face, posted to
          your socials every day.
        </Typography>
        <CtaButton className={styles.button} />
      </div>
    </Section>
  );
};
